module.exports = __webpack_public_path__ + "static/media/durotype-flexosoft-heavy.20dbede0.otf";